import { Observable } from 'rxjs';

import { catchErrorLogRet } from '../../../common/rest.operators';
import { epicDependencies } from '../../../store';
import { Run, ScheduleService } from '../../backend';
import { Job } from '../../backend/model/job.model';

import { createParams } from './create-params.function';

export function createJob(): Observable<Job | null> {
    const scheduleService =
        epicDependencies.injector.get<ScheduleService>(ScheduleService);

    const bp = createParams();
    const run: Run = {
        runId: null,
        parameters: JSON.stringify(bp),
        timestamp: null,
        createdBy: null,
        results: null,
    };
    const job: Job = {
        fullName: null,
        cronExpression: '',
        run,
    };

    return scheduleService.create(job).pipe(catchErrorLogRet(null));
}
